module.exports = __webpack_public_path__ + "img/StartSWBanner_line-2.b7232328.png";